import { Sun, BookOpen, Users, Droplets, MapPin, LifeBuoy, Home as HomeIcon } from "lucide-react";
import { Link } from "react-router-dom";

const PROGRAMMES = [
  {
    serial: "DKF-PGM-2026-000001",
    icon: Sun,
    title: "Light Up Rural Nigeria",
    text: "Solar mini-grids, clean energy access, safety training and community-led maintenance.",
    image: "https://images.unsplash.com/photo-1776090416729-20bedcc1a207?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVscyUyMHJ1cmFsJTIwYWZyaWNhfGVufDB8fHx8MTc4MjYwOTU1M3ww&ixlib=rb-4.1.0&q=85",
    href: "/donate",
  },
  {
    serial: "DKF-PGM-2026-000002",
    icon: BookOpen,
    title: "Sponsor a Child's Education",
    text: "Scholarships, school fees, learning materials, examination support and mentorship.",
    image: "https://images.unsplash.com/photo-1617056239820-8ce90ba48193?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxhZnJpY2FuJTIwY2hpbGRyZW4lMjBzY2hvb2x8ZW58MHx8fHwxNzgyNjA5NTUzfDA&ixlib=rb-4.1.0&q=85",
    href: "/donate",
  },
  {
    serial: "DKF-PGM-2026-000003",
    icon: Users,
    title: "Empower Women & Youth",
    text: "Skills training, agriculture value chains, micro-support and enterprise development.",
    image: "https://images.unsplash.com/photo-1509099381441-ea3c0cf98b94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxhZnJpY2FuJTIwd29tZW4lMjBhZ3JpY3VsdHVyZXxlbnwwfHx8fDE3ODI2MDk1NTN8MA&ixlib=rb-4.1.0&q=85",
    href: "/empowerment",
  },
  {
    serial: "DKF-PGM-2026-000004",
    icon: Droplets,
    title: "Water • Food • Emergency",
    text: "Humanitarian response for families and communities facing urgent hardship.",
    image: "https://images.unsplash.com/photo-1586900632557-b99cf3b226cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMHdhdGVyJTIwcHVtcCUyMHZpbGxhZ2V8ZW58MHx8fHwxNzgyNjA5NTUzfDA&ixlib=rb-4.1.0&q=85",
    href: "/family-support",
  },
  {
    serial: "DKF-PGM-2026-000005",
    icon: HomeIcon,
    title: "Shelter & Housing",
    text: "Emergency shelter, home repair, rebuilding after disaster and safe homes for vulnerable families.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800",
    href: "/housing",
  },
  {
    serial: "DKF-PGM-2026-000006",
    icon: MapPin,
    title: "Community Development",
    text: "Needs assessments, leadership engagement, partnerships and sustainable plans.",
    image: "https://images.unsplash.com/photo-1565958923272-e96dbb1e8414?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxuaWdlcmlhJTIwdmlsbGFnZSUyMGxpZmV8ZW58MHx8fHwxNzgyNjA5NTUzfDA&ixlib=rb-4.1.0&q=85",
    href: "/apply",
  },
  {
    serial: "DKF-PGM-2026-000007",
    icon: LifeBuoy,
    title: "Emergency Relief Fund",
    text: "A flexible rapid-response fund for urgent community needs.",
    image: "https://images.pexels.com/photos/6995301/pexels-photo-6995301.jpeg",
    href: "/donate",
  },
];

export default function ProgrammesGrid({ compact = false }) {
  return (
    <section className={`${compact ? "py-16" : "py-20 md:py-24"} bg-white`} data-testid="programmes-grid">
      <div className="dk-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-[#0d1724] tracking-[0.3em] text-xs font-semibold uppercase">What we do</span>
            <h2 className="font-serif text-[#0a0d12] text-3xl md:text-5xl font-bold mt-3">Programmes built around people.</h2>
          </div>
          <p className="text-[#0a0d12]/70 max-w-md text-base leading-relaxed">
            Seven programmes — designed in partnership with communities and delivered with measurable accountability.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROGRAMMES.map((p, idx) => {
            const Icon = p.icon;
            return (
              <Link
                to={p.href || "/programmes"}
                key={p.title}
                className="group relative rounded-2xl overflow-hidden h-72 cursor-pointer border border-black/5 block"
                data-testid={`programme-card-${idx}`}
              >
                <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#155e3f] via-[#155e3f]/70 to-[#155e3f]/20 group-hover:from-[#155e3f] group-hover:via-[#155e3f]/80 transition-all" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="w-11 h-11 rounded-full bg-[#d6aa43] text-[#0a0d12] flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                    <Icon size={20} />
                  </div>
                  {p.serial && (
                    <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#d6aa43] font-bold mb-1">{p.serial}</div>
                  )}
                  <h3 className="font-serif text-white text-xl font-bold mb-1">{p.title}</h3>
                  <p className="text-sm text-white leading-relaxed">{p.text}</p>
                </div>
              </Link>
            );
          })}
        </div>
        {compact && (
          <div className="mt-10 text-center">
            <Link to="/programmes" className="dk-btn-outline !text-[#0d1724] !border-[#0d1724] hover:!bg-[#155e3f] hover:!text-[#d6aa43]">
              See all programmes
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
